import { Box, Modal } from '@mui/material'
import React from 'react'

const CustomModal = ({ children, open = false, handleClose, padding, width, styles, height, borderRadius }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width,
    height,
    overflow: 'hidden',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: borderRadius || 0,
    p: padding || 0,
    ...styles,
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>{children}</Box>
    </Modal>
  )
}

export default CustomModal
